export default {
  description: 'Has seleccionado la opción "Otra" porque tu contenido no responde a ninguna de las temáticas ya listadas en Kimple. Por eso, nos gustaría saber:',
  title: '¿Cómo llamarías a esa nueva temática?',
  label: 'Nombre de la temática:',
  thanks: '¡Gracias por tu respuesta! Lo tendremos en cuenta para futuras mejoras.',
  send: 'Enviar'
}

export const en = {
  description: 'You have selected "Other topic" because your content does not match any of the topics listed on Kimple. Therefore, we would like to know:',
  title: 'What would you name this new topic?',
  label: 'Topic name:',
  thanks: 'Thanks for your answer! We will take this into account for future improvements.',
  send: 'Send'
}

export const ca = {
  description: 'Has seleccionat l\'opció "Altra" perquè el teu contingut no respon a les temàtiques ja llistades en Kimple. Per això, ens agradaria saber:',
  title: 'Com nomenaries aquesta nova temàtica?',
  label: 'Nom de la temàtica:',
  thanks: 'Gràcies per la teva resposta! Ho tindrem en compte per a futures millores.',
  send: 'Enviar'
}
